import { useCampaignGroupStore } from '~/modules/campaign-group';
import { removeDuplicates } from '~/utils/removeDuplicates';
import { ICampaignType } from '~/modules/campaign/types';
import { CAMPAIGN_STATUS } from '~/constants/campaign';
import { useMemo } from 'react';

export const useCampaignGroupTemplateListing = () => {
  const campaignGroups = useCampaignGroupStore((state) => state.campaignGroups || []);

  const data = useMemo(() => {
    const listCampaignGroup = campaignGroups.filter(
      (item) => item.type === ICampaignType.TEMPLATE_BUNDLE,
    );
    return removeDuplicates(listCampaignGroup, ['id']);
  }, [campaignGroups]);

  const dataActive = useMemo(() => {
    const listCampaignGroup = data.filter((item) => item.status !== CAMPAIGN_STATUS.DRAFT);
    return listCampaignGroup;
  }, [data]);

  return {
    data,
    dataActive,
  };
};
